export default __webpack_public_path__ + "static/media/to.aa312713.svg";